import React from "react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

const Tables = ({ tableHeaders, tableDataToShow, columnActions = [], sortConfig, onSort }) => {
  const getSortIcon = (columnIndex) => {
    if (sortConfig.key !== columnIndex) {
      return <FaSort className="inline-block ml-1 text-gray-400" />;
    }
    return sortConfig.direction === 'asc' 
      ? <FaSortUp className="inline-block ml-1 text-gray-600" />
      : <FaSortDown className="inline-block ml-1 text-gray-600" />;
  };

  return (
    <div className="overflow-x-auto shadow-md sm:rounded-lg">
      <table className="min-w-full text-sm text-left">
        <thead className="bg-gray-50">
          <tr>
            {tableHeaders &&
              tableHeaders.map((item, index) => (
                <th
                  key={index}
                  className="px-6 py-3 text-xs font-medium uppercase cursor-pointer hover:bg-gray-100"
                  onClick={() => onSort && onSort(index)}
                >
                  <div className="flex items-center">
                    {item}
                    <span className="ml-1">
                      {getSortIcon(index)}
                    </span>
                  </div>
                </th>
              ))}
          </tr>
        </thead>
        <tbody className="bg-white">
          {tableDataToShow.length > 0 &&
            tableDataToShow.map((items, rowIndex) => (
              <tr key={rowIndex} className="border-b">
                {items.map((item, colIndex) => (
                  <td key={colIndex} className="px-6 py-4">
                    {/* If an action (icon + function) is passed for this column */}
                    {columnActions[colIndex] ? (
                      columnActions[colIndex].icon ? (
                        <button
                          onClick={() => columnActions[colIndex].action(rowIndex, items)}
                        >
                          {columnActions[colIndex].icon}
                        </button>
                      ) : (
                        columnActions[colIndex].action(rowIndex, items)
                      )
                    ) : (
                      item
                    )}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Tables;
